export default __webpack_public_path__ + "static/media/premium-thumbnail-syb.ded2c1af.svg";